import { render, staticRenderFns } from "./PosProductBrowser.vue?vue&type=template&id=5553ffa8&scoped=true&"
import script from "./PosProductBrowser.vue?vue&type=script&lang=js&"
export * from "./PosProductBrowser.vue?vue&type=script&lang=js&"
import style0 from "./PosProductBrowser.vue?vue&type=style&index=0&id=5553ffa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553ffa8",
  null
  
)

export default component.exports